module.exports = __webpack_public_path__ + "static/img/2aw.d90ad9b5.webp";